




























import { Configuration, DoctorPaymentRestControllerApi, ReceiptOverview, InvoiceDetail } from '@/types/api-docs'
import { DataTableHeader } from 'vuetify'
import InvoiceForm from '@/components/InvoiceForm.vue'
import Vue from 'vue'

const paymentApi = new DoctorPaymentRestControllerApi(new Configuration({ basePath: `${window.location.origin}` }))

export type DataType = {
  pageName: string
  breadcrumbs: unknown[]
  invoice?: InvoiceDetail
  downloadedInvoices?: Array<ReceiptOverview>
  paymentId: number
  isFormValid: boolean
  nowDownloadingInvoice: boolean
}

export type BreadcrumbsRow = {
  text: string
  href: string
  disabled: boolean
}

export default Vue.extend({
  components: {
    InvoiceForm,
  },
  data(): DataType {
    return {
      pageName: this.$route.meta.title,
      breadcrumbs: [
        {
          text: 'HOME',
          href: '/member',
        },
        {
          text: this.$store.getters.preRoute?.meta.title || '支払情報',
          href: this.$store.getters.preRoute?.name ? this.$store.getters.preRoute?.path : '/member/payments',
          disabled: !this.$store.getters.preRoute?.name,
        },
        {
          text: `${this.$route.meta.title}`,
          disabled: true,
        },
      ],
      invoice: undefined,
      paymentId: Number(this.$route.params.id),
      isFormValid: true,
      nowDownloadingInvoice: false,
    }
  },
  async mounted() {
    this.replaceSecondBreadcrumb()

    await this.fetchInvoiceDetail()
  },
  methods: {
    replaceSecondBreadcrumb() {
      if (this.breadcrumbs.length < 2) {
        return
      }
      let row = this.breadcrumbs[1] as unknown as BreadcrumbsRow
      if (!row.disabled) {
        return
      }
      let pathElems = this.$route.path.split('/')
      const paymentType = pathElems.slice(-3)[0]
      pathElems.splice(pathElems.length - 2, 2)
      row.text = this.judgePageTitle(paymentType)
      row.href = pathElems.join('/')
      row.disabled = false

      this.breadcrumbs.splice(1, 1, row)
    },
    async fetchInvoiceDetail() {
      const { data } = await paymentApi.fetchInvoiceDetail(this.paymentId)
      this.invoice = data
    },
    async downloadInvoice() {
      this.nowDownloadingInvoice = true
      window.location.href = window.location.origin + '/api/member/payments' + '/invoice/download/' + this.paymentId
    },
    judgePageTitle(paymentType: string): string {
      if (paymentType === 'annualFees') {
        return '年会費一覧'
      } else if (paymentType === 'qualifications') {
        return '資格・認定入金一覧'
      } else if (paymentType === 'etcs') {
        return 'その他入金一覧'
      }
      return '支払情報'
    },
  },
})
